import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=b4e3a60e&scoped=true"
import script from "./ThemeEditor.vue?vue&type=script&lang=js"
export * from "./ThemeEditor.vue?vue&type=script&lang=js"
import style0 from "./ThemeEditor.vue?vue&type=style&index=0&id=b4e3a60e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e3a60e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e3a60e')) {
      api.createRecord('b4e3a60e', component.options)
    } else {
      api.reload('b4e3a60e', component.options)
    }
    module.hot.accept("./ThemeEditor.vue?vue&type=template&id=b4e3a60e&scoped=true", function () {
      api.rerender('b4e3a60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/ThemeEditor.vue"
export default component.exports